// Stickers de Noah recortados de las láminas oficiales (public/brand/stickers)
export const NOAH_STICKERS = [
  { key: 'hola', text: '¡Hola!' },
  { key: 'adios', text: '¡Adiós!' },
  { key: 'gracias', text: '¡Gracias!' },
  { key: 'gracias_corazon', text: '¡Gracias!' },
  { key: 'listo', text: '¡Listo!' },
  { key: 'genial', text: '¡Genial!' },
  { key: 'perfecto', text: '¡Perfecto!' },
  { key: 'felicidades', text: '¡Felicidades!' },
  { key: 'pensando', text: 'Déjame pensar…' },
  { key: 'revisando', text: 'Estoy revisando' },
  { key: 'idea', text: '¡Tengo una idea!' },
  { key: 'me_encargo', text: '¡Yo me encargo!' },
  { key: 'ups', text: '¡Ups!' },
  { key: 'lo_siento', text: 'Lo siento…' },
  { key: 'mira_esto', text: 'Mira esto' },
  { key: 'en_eso', text: 'Estoy en eso…' },
  { key: 'trabajando', text: 'Trabajando en ello…' },
  { key: 'vamos', text: '¡Vamos!' },
  { key: 'pregunta', text: '¿?' },
  { key: 'te_ayudo', text: '¿Te ayudo?' },
  { key: 'aqui_tienes', text: 'Aquí tienes' },
  { key: 'listo_compartir', text: '¡Listo para compartir!' },
  { key: 'en_camino', text: '¡En camino!' },
  { key: 'un_momento', text: '¡Un momento!' },
];

export const STICKER_MAP = NOAH_STICKERS.reduce((acc, s) => {
  acc[s.key] = s;
  return acc;
}, {});

export const stickerSrc = (key) => {
  if (!key) return null;
  if (key.startsWith('c_')) return `${process.env.REACT_APP_BACKEND_URL}/api/noah/stickers/custom/${key.slice(2)}.png`;
  return STICKER_MAP[key] ? `/brand/stickers/${key}.png` : null;
};

// Por si algún mensaje viejo trae el marcador sin procesar
const MARKER = /\[\[\s*sticker\s*:\s*([a-z0-9_-]{2,48})\s*\]\]/i;

export function parseSticker(content = '') {
  const m = content.match(MARKER);
  const raw = m ? m[1].toLowerCase() : null;
  const key = raw && (STICKER_MAP[raw] || raw.startsWith('c_')) ? raw : null;
  return { text: content.replace(MARKER, '').trim(), key };
}
